import Action from '../base/action';

class MediaScreenFocus extends Action {
    mediaId;

    constructor(props) {
        super({...props, className: props.className || props.type + '_class'});
        this.mediaId = props.instanceId;
    }

    async execute({training}) {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        media.teleportToFocus();
    }

    async stop() {
        const media = MediaScreenManager.getMediaScreenFromInstanceId(this.mediaId);

        if (isNullOrUndefined(media)) {
            console.log('Media not found for id: ' + this.mediaId);
            return;
        }

        MediaScreenManager.changeScreenVisibility(media.params.screenID, false);
    }
}

export default MediaScreenFocus;
